// extracted by mini-css-extract-plugin
export var chevronIcon = "_55-2";
export var teamName = "_55-1";
export var teamSwitcherButton = "_55-0";